module.exports = __webpack_public_path__ + "img/music_on.c91e3cf5.png";